import { Commit, ActionTree } from 'vuex';
import { State } from '@/store/modules/mobile/mobileCommonState/mobileCommon.store';
import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';

const actions: ActionTree<State, any> = {
  async GET_CRASH_META(
    context: { commit: Commit },
    params: {
      serviceId: String;
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      sortKey: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetCrashData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.crashEvents;
        } else return [];
      })
      .catch((err) => console.log('error', err));
  },
  async GET_PERFORMANCE_ERROR_SUMMURY_META(
    context: { commit: Commit },
    params: {
      serviceId: String;
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      sortKey: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetPerformanceErrorEventSummuryData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.performanceErrorSummary;
        } else return [];
      })
      .catch((err) => console.log('error', err));
  },
  async GET_PERFORMANCE_ERROR_META(
    context: { commit: Commit },
    params: {
      serviceId: String;
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      sortKey: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetPerformanceErrorEventData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.performanceErrorOverview;
        } else return [];
      })
      .catch((err) => console.log('error', err));
  },
  async GET_TOP_LOCATION_META(
    context: { commit: Commit },
    params: {
      serviceId: String;
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      sortKey: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryCrashInfoByCountry')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.crashInfoByCountry;
        } else return [];
      })
      .catch((err) => console.log('error', err));
  },
  async GET_PERFORMANCE_TOP_LOCATION_META(
    context: { commit: Commit },
    params: {
      serviceId: String;
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      sortKey: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryPerformanceInfoByCountry')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.performanceInfoByCountry;
        } else return [];
      })
      .catch((err) => console.log('error', err));
  },
  async GET_CRASH_EVENT_DETAIL(
    context: { commit: Commit; rootState: any },
    params: {
      serviceId: String;
      os: Array<String>;
      versionId: Array<String>;
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      sortKey: String;
      message: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetCrashEventData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.crashLogsSummary;
        } else return {};
      })
      .catch((err) => console.log('error', err));
  },
  async GET_CRASH_EVENT_SUMMARY(
    context: { commit: Commit; rootState: any },
    params: {
      crashId: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetCashIDInfo')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.crashByID;
        } else return {};
      })
      .catch((err) => console.log('error', err));
  },
  async GET_PERFORMANCE_ERROR_EVENT_SUMMARY_DETAILS(
    context: { commit: Commit; rootState: any },
    params: {
      eventId: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('performanceErrorDetailsByID')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.performanceErrorDetailsByID;
        } else return {};
      })
      .catch((err) => console.log('error', err));
  },
  async GET_CRASH_LOCATION_SUMMARY(
    context: { commit: Commit; rootState: any },
    params: {
      serviceId: String;
      os: Array<String>;
      versionId: Array<String>;
      duration: {
        start: String;
        end: String;
        step: String;
      };
      countryCode: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryInfoByCountry')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.infoByCountry;
        } else return {};
      })
      .catch((err) => console.log('error', err));
  },
  async GET_HTTP_REQ_META(
    context: { commit: Commit },
    params: {
      serviceId: String;
      pagination: {
        pageNum: Number;
        pageSize: Number;
        needTotal: Boolean;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      sortCol: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetHttpReqData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.topHttpRequest;
        } else return [];
      })
      .catch((err) => console.log('error', err));
  },
  async GET_PERFORMANCE_EVENT_DETAIL(
    context: { commit: Commit; rootState: any },
    params: {
      serviceId: String;
      os: Array<String>;
      versionId: Array<String>;
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      sortKey: String;
      message: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGethttpRequestsData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.performanceLogsSummary;
        } else return {};
      })
      .catch((err) => console.log('error', err));
  },
  async GET_HTTP_REQ_SUMMARY(
    context: { commit: Commit; rootState: any },
    params: {
      serviceId: String;
      os: Array<String>;
      versionId: Array<String>;
      duration: {
        start: String;
        end: String;
        step: String;
      };
      endpointName: String;
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetHttpReqInfo')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.endpointInfoMobile;
        } else return {};
      })
      .catch((err) => console.log('error', err));
  },
};

export default actions;
